module.exports = __webpack_public_path__ + "img/thumb_2021-03.326bf1e6.jpg";